import styled from 'styled-components'
import Box from '~/components/UI/Box'
import FAQSection from '~/components/FAQSection'
import CD from './CD'
import MF from './MF'
import Clients from './Clients'
import Compare from './Compare'
import EasyInvest from './EasyInvest'
// import Experts from "./Experts"
import Intro from './Intro'
import Press from './Press'
import RealEstate from './RealEstate/RealEstate'
import Saving from './Saving'
import Download from './Download'
import Investors from './Investors'
import Partners from './Partners'
import { useTranslation } from '~/i18n'
// import firestore from '~/modules/firestore'
// import { useEffect, useState } from "react"

const MyContainer = styled(Box)`
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
`

const Home = () => {
  const [t] = useTranslation()
  const FAQquestions = [
    {
      id: 1,
      q: t`Tiền gửi vào Tích lũy được dùng để làm gì?`,
      a: t`Tiền gửi Khách hàng gửi vào sản phẩm Tích lũy được quản lý và đầu tư bởi Công ty Quản lý quỹ ABC (ACB Capital). Sản phẩm đầu tư bao gồm các sản phẩm có độ an toàn cao như chứng chỉ tiền gửi, trái phiếu`,
    },
    {
      id: 2,
      q: t`Tiền lãi Tích luỹ được trả như thế nào ?`,
      a: t`Tiền lãi sản phẩm Tích lũy được tính vào cuối mỗi ngày dựa trên số dư tại thời điểm tính. Tổng tiền lãi đã tích lũy sẽ được chi trả vào ngày 28 mỗi tháng`,
    },
    {
      id: 3,
      q: t`Lãi suất đáo hạn của chứng chỉ tiền gửi được tính như thế nào?`,
      a: t`Lợi nhuận của sản phẩm CCTG là mức Lãi suất đáo hạn được quy định tại CCTG. Lãi suất đáo hạn nhận được được tính dựa theo số ngày nắm giữ và số tiền đầu tư`,
    },
    {
      id: 4,
      q: t`Chứng chỉ quỹ là gì?`,
      a: t`Nói cách đơn giản, Chứng chỉ quỹ là sản phẩm đầu tư giúp bạn có thể đầu tư vào cổ phiếu, trái phiếu một cách gián tiếp thông qua các quỹ đầu tư uy tín hàng đầu.`,
    },
  ]

  return (
    <MyContainer>
      <Intro />
      <Press />
      <EasyInvest />
      <Saving />
      <CD />
      <MF />
      <RealEstate />
      <Compare />
      <Clients />
      <Investors />
      <Partners />
      {/* <Experts /> */}
      <FAQSection content={FAQquestions} />
      <Download />
    </MyContainer>
  )
}

export default Home
